import {
  OutputTypeForBENEFICIARY_PROFILE_FILE_LOAD,
  OutputTypeForFILE_IMPORT,
  OutputTypeForFILE_SUMMARY_SUGGEST,
  OutputTypeForRESOURCES_FILE_LOAD,
} from '../dtos/organization'
import { getPath, setP } from './helpers'

export namespace FilesRoutes {
  export namespace processFile {
    export function call(
      p = setP(['organizationId', 'processFilePromptTemplateType']),
    ) {
      return getPath(p)
    }
    export type Request = { formData: FormData }
    export type Response = {
      promptResult:
        | OutputTypeForFILE_SUMMARY_SUGGEST
        | OutputTypeForRESOURCES_FILE_LOAD
        | OutputTypeForBENEFICIARY_PROFILE_FILE_LOAD
        | OutputTypeForFILE_IMPORT
    }
  }
}
